// removed by extract-text-webpack-plugin
module.exports = {"userMenuFull":"_1VkBTXZVMqUryOqO","user":"_1NiMdDDc9of2RcIi","name":"_2mtsp1-LU-VPEC-c","myPageLink":"_24SntJU1leRz9hoX","enter":"jrr3FbSvcb-vqJLh","enterActive":"_2OsnNsmQ4X6p-Z3V","leave":"_105sKpmvrIQeOB4D","leaveActive":"_34GwoOI0zHImy5R1"};


//////////////////
// WEBPACK FOOTER
// ./app/components/User/UserMenu/UserMenuFull.pcss
// module id = 512
// module chunks = 1